export default {"src":"/_next/static/media/kinda-sloped.db8f1240.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};